var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigyBooksLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2181_63911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.65332 32.4308V24.6028L25.0939 35.9577V27.872L5.65332 16.6019V8.6021L25.0939 19.9723V11.9562L11.3308 4.04338L18.2988 0L32.8361 8.51621C33.0557 8.72605 34.4408 10.0905 34.3419 12.1725C34.2592 13.9067 33.1785 15.4766 31.5466 16.2583C29.4537 17.4967 27.3597 18.735 25.2668 19.9723L31.1161 23.3688C33.3101 24.5343 34.4604 26.8718 34.0016 28.9984C33.5199 31.2272 31.4814 32.2525 31.202 32.3873C26.8726 34.9248 22.5422 37.4624 18.2129 40L5.65332 32.4308Z",
    fill: "#3347FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2181_63911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.6929,
    height: 40,
    fill: "white",
    transform: "translate(5.65332)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigyBooksLogoIcon);
export default __webpack_public_path__ + "static/media/digy-books-logo-icon.c5af9ceb1748c5757d060e4790d14689.svg";
export { ForwardRef as ReactComponent };